import React, { useEffect, useState } from "react";
import "./View_All_Coupon_Code.css";
import { useDispatch, useSelector } from "react-redux";
import { getCoupons } from "../../../../features/home/homeSlice";
import { Form, Modal } from "react-bootstrap";

function View_All_Coupon_Code({ ...props }) {
  const [copyStatus, setCopyStatus] = useState("Copy");
  const [showTooltip, setShowTooltip] = useState(false);
  const [code, setCode] = useState("");
  const is_signin = useSelector((state) => state.auth.is_signin);
  const user = useSelector((state) => state.user.userInfo);

  useEffect(() => {
    setCode(user?.refer_code);
  }, [code]);

  const [copiedId, setCopiedId] = useState(null);
  // const [copyStatus, setCopyStatus] = useState("Copy");

  const handleCopy = (id, textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopiedId(id);
      setCopyStatus("Copied");

      setTimeout(() => {
        setCopiedId(null);
        setCopyStatus("Copy");
      }, 1500);
    });
  };

  //   const handleCopy = (id) => {
  //     navigator.clipboard.writeText(code).then(() => {
  //       setCopyStatus("Copied");
  //       setShowTooltip(true);
  //       setTimeout(() => {
  //         setCopyStatus("Copy");
  //         setShowTooltip(false);
  //       }, 1500);
  //     });
  //   };

  const dispatch = useDispatch();
  const allCoupons = useSelector((state) => state.home.addCoupons);

  useEffect(() => {
    dispatch(getCoupons());
  }, [dispatch]);

  // const chunkArray = (array, size) => {
  //   const result = [];
  //   for (let i = 0; i < array.length; i += size) {
  //     result.push(array.slice(i, i + size));
  //   }
  //   return result;
  // };
  // const groupedCoupons = Array.isArray(allCoupons?.data)
  //   ? chunkArray(allCoupons.data, 5)
  //   : [];
  return (
    <>
      <Modal
        {...props}
        size="lg"
        className="Cancel_Reason_Modal Modal-holder View_All_Coupon_Code_modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            All Coupon Code
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="content_holder">
            <div className="row">
              {allCoupons?.data?.map((val) => (
                <div className="col-md-12">
                  <div className="All_offers_sec">
                    <div className="mid-sec">
                      <div className="bannerdiv ">
                        <img
                          className="thirdoffer"
                          src={process.env.REACT_APP_IMAGE_URL + val?.image}
                          alt="thirdoffer"
                        />
                        <div className="btnpos">
                          <div
                            className="codediv mb-1"
                            style={{ position: "relative" }}
                          >
                            <Form.Control
                              type="search"
                              placeholder="Enter Code"
                              value={val?.code}
                              onChange={(e) => setCode(e.target.value)}
                            />
                            <button
                              className="searchbtn"
                              type="button"
                              // onClick={() =>
                              //   handleCopy(val?.id, val?.code)
                              // }
                              onClick={() => props.onApply(val?.code)}
                              onMouseLeave={() => setCopiedId(null)}
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default View_All_Coupon_Code;
